// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"259463b4","977":"47a9915b"}[chunkId] + ".chunk.js";
};